import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListSelectionTestDialogComponent } from '../process-list-selection-test-dialog/process-list-selection-test-dialog.component';
import { OneSignalService } from 'src/services/onesignal.service';

@Component({
  selector: 'app-process-list-multiple-selection-test-dialog',
  templateUrl: './process-list-multiple-selection-test-dialog.component.html',
  styleUrls: ['./process-list-multiple-selection-test-dialog.component.scss']
})
export class ProcessListMultipleSelectionTestDialogComponent implements OnInit {

  tests: Array<any>;
  candidatesId: Array<string> = [];
  processListId: string;
  @ViewChild('selectionTestList', { static: false }) selectionTestList: MatSelectionList;
  submiting: boolean = false;
  private currentUser: any;
  processList: any;
  processListTest: Array<any> = [];

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<ProcessListSelectionTestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private snackbar: MatSnackBar,
    private oneSignalService: OneSignalService,
  ) { 

    this.processListId = data.processListId;
    this.candidatesId = data.candidatesId;
    this.processList = data.processList;
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('token'));
    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;          
        if(scope.indexOf('process_list') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)
    this.getSelectionTest();
    this.getProcessListTest();
  }

  getSelectionTest() {

    const params = {
      companyId: this.currentUser.company_id
    }

    this.http.list('selection_test', params)
      .subscribe(
        (tests: any) => {
          this.tests = tests;
        },
        err => this.errorReport.showMessage(err)
      )
    
  }

  submit() {

    if(!confirm('Deseja realmente aplicar esses testes a esses candidatos?'))
      return

    const tests = this.selectionTestList.selectedOptions.selected.map(selected => selected.value);
    const data = {
      tests,
      processList: this.processListId,
      candidates: this.candidatesId
    }
    
    this.http.save('process_list:test', data)
      .subscribe(
        () => {
          
          this.http.save('onsignal:getUser', {leads: { lead_ids: this.candidatesId }})
            .subscribe(
              (result: any) => {
                if (result.type === 'OK') {
                  const signatureIds = result.data.map((item: any) => item.signature_id); // Extrai os signature_ids
                  //console.log('assinaturas', signatureIds);
                  const notification_for_all = null;
                  const title = 'Novo Teste';
                  const fullname = null;
                  
                  // Mapear o nome dos testes correspondentes aos IDs selecionados
                  const testNames = tests.map((testId: any) => {
                    const matchingTest = this.tests.find((item: any) => item.id === testId);
                    return matchingTest ? matchingTest.name : null; // Retorna o nome se encontrado, caso contrário, null
                  });
                  
                  // Converte o array de nomes em uma única string separada por vírgulas
                  const testNamesString = testNames.filter(name => name !== null).join(', ');

                  const message = this.oneSignalService.listMessage(7, fullname, this.processList.name, testNamesString );
                  
                  // Envia os dados para a função do backend que lida com as notificações
                  this.oneSignalService.sendNotification(signatureIds, title, message, notification_for_all)
                  .subscribe(
                    (result: any) => {
                      if (result.type === 'OK') {
                        this.oneSignalService.listNotification();
                      } else {
                        console.error('Erro ao enviar notificação para o candidato sobre o teste');
                      }
                    },
                    err => {
                      console.error('Erro ao enviar notificação ao candidato novo teste', err);
                      this.errorReport.showMessage(err);
                    }
                  );
                } else {
                  console.error('Erro ao obter dados para o envio da notificação');
                }
              },
              err => this.errorReport.showMessage(err)
            )

          this.snackbar.open('Testes enviados com sucesso!', 'OK', { duration: 3000 });
          this.dialogRef.close(true);
        },
        err => this.errorReport.showMessage(err)
      )

  }

  getProcessListTest() {

    const data = {
      processList: this.processListId,
      userId: this.candidatesId
    };
    
    this.http.list('user_process_list:test', data)
      .subscribe(
        (result: any) => {
          this.processListTest = result.data;
        },
        err => this.errorReport.showMessage(err)
      )
      
  }

  hasProcessListTestSelected(test) {

    if(this.processListTest.length === 0)
      return false;
    
    return this.processListTest.findIndex(_test => _test.id == test.id) > -1;    

  }

  hasProcessListTestPending(test) {

    if(this.processListTest.length === 0)
      return false;
    
    return this.processListTest.findIndex(_test => {
      return _test.id == test.id && _test.status !== 'pending'
    }) > -1;

  }

}
